import { Component, OnInit, ViewChild, Input, EventEmitter } from '@angular/core';
import {
  ConfirmComponent,
  Tarea,
  Context,
  TaskEvent,
  Const,
  ConfigFinishDefault,
  DynamicComponentForm
} from '@app/shared';

@Component({
  selector: 'iw-attached',
  templateUrl: './attached.component.html',
  styleUrls: ['./attached.component.scss']
})
export class AttachedComponent extends DynamicComponentForm implements OnInit {

  // Variable que trae la información de la tarea.
  @Input() ctx: Context;
  // Variable que sirve para disparar el evento de las finalizaciones
  @Input() event: EventEmitter<TaskEvent>;
  // Define cuando activar la previsualizacion de informacion de flujo
  @Input() previewFlow = false;
  // tipo del proceso de la tarea renderizada
  typeProcess: string;
  // Define la finaliacioncion de la tarea
  finishTask = false;
  // Define si hay una secundaria iniciada
  secondaryActive = false;
  // Variable que activa el gift de cargando cuando se está finalizando
  isLoadingFinish = false;
  // Determina si el usuario en sesion es responsable de la tarea
  userResponsible = false;
  // Variable que contiene el objeto de la tarea
  task: Tarea;
  // Referencia al componente de confirmación
  @ViewChild('confirmFinish') private confirmFinish: ConfirmComponent;

  constructor() {
    super();
  }

  ngOnInit() {
    if(this.previewFlow){
      this.finishTask = true;
    }
    this.task = this.ctx.task;
    this.typeProcess = this.ctx.typeProcess;
    if (
      this.task &&
      this.task.tarea_estado &&
      this.task.tarea_estado.nombre === Const.STATUS_TASK.finished
    ) {
      this.finishTask = true;
    }
    if (
      this.task &&
      this.task.tarea_estado &&
      this.task.tarea_estado.nombre === Const.STATUS_TASK.secondaryProgress
    ) {
      this.secondaryActive = true;
    }
  }

  /**
   * Función que realiza las validaciones de la finalización.
   *
   * @param {boolean} res
   * @memberof AttachedComponent
   */
  finish() {
    this.confirmFinish.new({
      question: '¿Está seguro de finalizar la tarea?',
      labelConfirm: 'Si',
      labelDecline: 'No'
    }).then(res => {
      if (res) {
        const data: ConfigFinishDefault = {
          tarea: this.task.id
        };
        const e: TaskEvent = {
          type: 'finish',
          data: data
        };
        this.event.emit(e);
        this.close();
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/forms/all/attached/attached.component.ts